import { render } from "./AuthProviderWarningBanners.vue?vue&type=template&id=39a4c35f&ts=true"
import script from "./AuthProviderWarningBanners.vue?vue&type=script&lang=ts"
export * from "./AuthProviderWarningBanners.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__